<template>
    <el-dialog v-model="opened" width="70%" :before-close="close">
        <template #header>
            <div style="display:flex;gap:10px;align-items:center">
                <el-tabs v-model="mode" type="card">
                    <el-tab-pane :label="`选择现有${cnType}`" name="select"></el-tab-pane>
                    <el-tab-pane v-if="allowCreate" :label="`新建${cnType}`" name="create"></el-tab-pane>
                </el-tabs>
            </div>
        </template>

        <div v-if="mode === 'select'">
            <!-- 左侧输入框，右侧搜索按钮；输入框回车/清空触发搜索 -->
            <div style="display:flex; align-items:center; gap:8px; margin-bottom:10px">
                <el-input
                    v-model="query.nickname"
                    placeholder="搜索名称..."
                    :disabled="loading"
                    clearable
                    style="flex: 1"
                    @keyup.enter="fetchData(1)"
                    @clear="fetchData(1)"
                ></el-input>
                <el-button type="primary" :disabled="loading" @click="fetchData(1)">搜索</el-button>
            </div>

            <div style="display:flex;flex-wrap:wrap;gap:12px;margin-top:10px">
                <el-card v-for="item in data" :key="item.id" shadow="hover" style="min-width: 120px; display: inline-block; white-space: nowrap;"
                    :class="{ 'selected': selectedIds.includes(item.id) }" @click="toggleSelect(item)">
                    <div style="position: relative;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: fit-content;
                            min-width: 180px;
                            margin: 0 auto;">
                            <div style="width: 30px;"></div>
                        <div style="flex: 1; text-align: center;">{{ item.nickname }}</div>
                        <el-popconfirm
                            title="删除库中数据?"
                            confirm-button-text="删除"
                            cancel-button-text="取消" 
                            @confirm="deleteItem(item)">
                            <template #reference>
                                <el-button
                                    text
                                    type="danger"
                                    size="small"
                                    icon="Delete"
                                    @click.stop
                                    style="margin-left: auto;"
                                ></el-button>
                            </template>
                        </el-popconfirm>
                    </div>
                    <div v-if="type === 'figure' && item.resource_url" style="text-align:center;margin-top:8px;margin-bottom:8px">
                        <el-image :src="`${$root.cdn_url}/${item.resource_url}`"
                            style="width:120px;object-fit:cover"></el-image>
                    </div>
                </el-card>
            </div>
        </div>

        <div v-else>
            <el-form :model="form" ref="formRef" label-width="100px">
                <el-form-item label="名称" prop="nickname" :rules="[{ required: true, message: '请输入名称' }]">
                    <el-input v-model="form.nickname" :disabled="loading"></el-input>
                </el-form-item>
                <el-form-item v-if="type === 'figure'" label="封面" :rules="[{ required: true, message: '请上传图片'}]">
                    <el-upload action="/cms/v1/resource"
                           :show-file-list="false"
                           :headers="{ authorization: $root.authorization }"
                           :data="{prefix: 'origin'}"
                           accept="image/*"
                           :disabled="loading"
                           :on-success="handleCoverSuccess"
                           :on-error="handleUploadError">
                        <el-image v-if="form.resource_url" :src="`${$root.cdn_url}/${form.resource_url}`"
                            style="width:200px"></el-image>
                        <el-button v-else :loading="loading">上传封面</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>

        <template #footer>
            <div style="display:flex;justify-content:space-between;align-items:center;width:100%">
                <div v-if="mode === 'select'">已选择 {{ selectedIds.length }} 项</div>
                <div style="display:flex;gap:8px">
                    <el-button text :disabled="loading" @click="close">取消</el-button>
                    <el-button v-if="mode === 'select'" type="primary" :loading="loading"
                        @click="confirmSelect">添加选中项</el-button>
                    <el-button v-else type="primary" :loading="loading" @click="create">创建并添加</el-button>
                </div>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import axios from 'ts-axios-new';
import { ElMessage } from 'element-plus';
import { update } from '../../libs/utils';

export default {
    name: 'SelectItemDialog',
    props: {
        type: { type: String, required: true }, // 'chapter' | 'topic' | 'figure'
        allowCreate: { type: Boolean, default: true }, // 默认允许新建
    },
    data() {
        return {
            opened: false,
            loading: false,
            parent: null, // 用于回传
            data: [],
            selectedIds: [],
            query: { nickname: null, skip: 0, limit: 10 },
            form: { nickname: '', resource_url: null, username: this.$root.user.name },
            mode: 'select',
        }
    },
    computed: {
        cnType() {
            return this.type === 'chapter' ? '章节' : this.type === 'topic' ? '主题' : '手办';
        },
        path() {
            return `/cms/v1/${this.type}`;
        }
    },
    methods: {
        open(context) {
            this.parent = context?.parent || null;
            this.selectedIds.splice(0, this.selectedIds.length);
            this.opened = true;
            this.fetchData(1);
        },
        close() { this.opened = false; this.loading = false; this.parent = null; },
        fetchData(page=1) {
            this.query.skip = page - 1;
            this.loading = true;
            axios.get(this.path, { params: this.query }).then(res => {
                const list = res.data?.data?.list || res.data?.data?.[`${this.type}List`] || [];
                this.data = list;
                this.loading = false;
            }).catch(e => {
                console.error(e);
                this.loading = false;
                ElMessage.error('获取列表失败，请稍后重试');
            });
        },
        toggleSelect(item) {
            const i = this.selectedIds.indexOf(item.id);
            if (i >= 0) this.selectedIds.splice(i, 1); else this.selectedIds.push(item.id);
        },
        async handleNewIds(idsToBind) {
            this.loading = true;
            try {
                const parentId = this.parent?.id;
                const parentType = this.parent?.type; // chapter-scheme / chapter / topic
                if (parentId && parentType) {
                    // 组装新的子 id 列表：原有 + 待绑定
                    const existIds = (this.parent.childIds || []).map(i => i.id);
                    const newIds = Array.from(new Set([...existIds, ...idsToBind]));
                    const childKeyName = this.type + "s";
                    await axios.patch(`/cms/v1/${parentType}/${parentId}`, {
                        username: this.$root.user.name,
                        [childKeyName]: newIds
                    });
                    // 通知父级刷新
                    this.parent.childIds = newIds
                    this.$emit('bindAndRefresh', this.parent);
                    this.close();
                }
            } catch (e) {
                console.error(e);
                this.loading = false;
                ElMessage.error('绑定失败，请稍后重试');
                // 新建失败时切到选择页并刷新
                if (this.mode === 'create') {
                    this.mode = 'select';
                    this.fetchData(1);
                }
                return; // 不再向外 emit
            }
        },
        async confirmSelect() {
            await this.handleNewIds(this.selectedIds);
        },
        async deleteItem(item) {
            try {
                this.loading = true;
                await axios.delete(`${this.path}/${item.id}`);
                // 从本地列表移除，并清理选择状态
                this.data = this.data.filter(i => i.id !== item.id);
                const idx = this.selectedIds.indexOf(item.id);
                if (idx >= 0) this.selectedIds.splice(idx, 1);
                ElMessage.success('删除成功');
            } catch (e) {
                console.error(e);
                ElMessage.error('删除失败，请稍后重试');
            } finally {
                this.loading = false;
            }
        },
        async create() {
            this.$refs.formRef.validate(async valid => {
                if (!valid) return;
                this.loading = true;
                let created;
                try {
                    // 1. 先创建实体
                    const res = await axios.post(this.path, this.form);
                    created = res.data?.data;
                    if (!created) { this.loading = false; return; }
                } catch (e) {
                    this.loading = false;
                }
                // 2. 立即绑定到父级
                await this.handleNewIds([created.id]);
            });
        },
        handleCoverSuccess(res) {
            this.loading = false;
            this.form.resource_url = res.data.name;
        },
        handleUploadError() {
            this.loading = false;
            ElMessage.error('上传失败，请稍后重试');
        }
    }
}
</script>

<style scoped>
.selected {
    border-color: var(--el-color-primary);
}
</style>